import React, { useContext, useState } from 'react';
import { OrdersContext } from '../context/orders.context';
import { processType } from '../utils/constant';
import moment from 'moment';
import { useNavigate, Link } from 'react-router-dom';
import { ChatRefContext } from '../context/chatRef.context';
import Chat from './Chat';
import ChatButton from './Chat/ChatButton';
import qs from 'query-string';
import CurrencyFormat from './CurrencyFormat';
import tickImage from '../assets/tick.svg';
import closeImage from '../assets/close.svg';

const OrderTable = ({ orderData }) => {
    console.log("Data :", orderData);
    const {
        activeTab,
    } = useContext(OrdersContext);
    const { selectedChatRefId, setSelectedChatRefId } = useContext(ChatRefContext);

    console.log("Chat ref ::", selectedChatRefId);

    const showDrawer = (id) => {

        if (id.startsWith('S')) {
            if (id[1] == '-') {
                id = id.slice(2)
            }
            else {
                id = id.slice(1)
            }
        }
        console.log("Setting id ::", id);
        setSelectedChatRefId(id)
    };

    const onClose = () => {
        setSelectedChatRefId(null)
    };

    const { search, } = window.location;
    const param = qs.parse(search);

    const navigate = useNavigate();



    return (
        <div className='relative overflow-x-auto w-full'>
            <Chat RefId={selectedChatRefId} open={selectedChatRefId} onDrawerClose={onClose} />

            <table className='w-full table-auto text-sm text-left text-gray-700'>
                <thead className='text-xs text-gray-700 uppercase bg-gray-50'>
                    <tr>
                        <th scope='col' className='px-6 py-2'>ORDER ID</th>
                        <th scope='col' className='px-6 py-2'>PROJECT NAME</th>
                        <th scope='col' className='px-6 py-2'>TYPE OF MFG. PROCESS</th>
                        <th scope='col' className='px-6 py-2'>REQUEST DATE</th>
                        <th scope='col' className='px-6 py-2 text-center'>PSD</th>
                        <th scope='col' className='px-6 py-2 text-center'>ESD</th>
                        {activeTab != 'active-orders' ? (
                            <th scope='col' className='px-6 py-2 text-center'>ASD</th>
                        ) : null}
                        {activeTab == 'closed-orders' || activeTab == 'delivered-orders' ? (
                            <th scope='col' className='px-6 py-2 text-center'>DELIVERY DATE</th>
                        ) : null}
                        <th scope='col' className='px-6 py-2 text-center'>STATUS</th>
                        <th scope='col' className='px-6 py-2 text-center'>ORDER VALUE</th>
                        <th scope='col' className='px-6 py-2 text-center'>PO NO.</th>
                        <th scope='col' className='px-6 py-2 text-center'>CHAT</th>
                    </tr>
                </thead>

                <tbody className='order-body'>
                    {orderData.length > 0 && orderData.map((item, i) => (
                        <tr key={i} className='bg-white border-b'>
                            <td className='px-6 py-2 font-medium underline whitespace-nowrap cursor-pointer'>
                                <Link className='text-primaryColor' to={`/order-details/${item._id}`}>{item?.pORefId}</Link>
                            </td>

                            <td className='px-6 py-2 max-w-32 whitespace-normal break-words'>
                                {item?.rfqs?.projectName}
                            </td>

                            <td className='px-6 py-2'>
                                {processType[item?.rfqs?.selectedProcess - 1]?.name}
                            </td>

                            <td className='px-6 py-2 whitespace-nowrap'>
                                {moment(item.createdAt).format('DD MMM YYYY')}
                            </td>

                            <td className='px-6 py-2 whitespace-nowrap text-center'>
                                {item?.poAcceptanceDate
                                    ? moment(item?.poAcceptanceDate).add(item?.supplierRfqOfferId?.leadTime, 'days').format('DD MMM YYYY')
                                    : moment(Date.now()).add(item?.supplierRfqOfferId?.leadTime, 'days').format('DD MMM YYYY')}
                            </td>

                            <td className='px-6 py-2 whitespace-nowrap text-center'>
                                {item?.expectedShippingDates?.length > 0
                                    ? moment(
                                        item?.expectedShippingDates.reduce((maxObj, currentObj) => {
                                            if (currentObj.updatedDate > maxObj.updatedDate) return currentObj;
                                            return maxObj;
                                        }).updateValue
                                    ).format('DD MMM YYYY')
                                    : item?.poAcceptanceDate
                                        ? moment(item?.poAcceptanceDate).add(item?.supplierRfqOfferId?.leadTime, 'days').format('DD MMM YYYY')
                                        : 'NA'}
                            </td>

                            {activeTab != 'active-orders' ? (
                                <td className='px-6 py-2 whitespace-nowrap text-center'>
                                    {item.shippedDate ? moment(item.shippedDate).format('DD MMM YYYY') : 'NA'}
                                </td>
                            ) : null}

                            {activeTab == 'closed-orders' || activeTab == 'delivered-orders' ? (
                                <td className='px-6 py-2 whitespace-nowrap text-center'>
                                    {item.deliveryDate ? moment(item.createdAt).format('DD MMM YYYY') : 'NA'}
                                </td>
                            ) : null}

                            <td className='px-6 py-2 text-center'>
                                <p className={
                                    activeTab === 'billed-orders' ? 'Shipped'
                                        : activeTab === 'active-orders' && item?.allBilledParts?.length > 0 ? 'Partially_Billed'
                                            : `${item.status.replaceAll(' ', '_')}`
                                }>
                                    {activeTab === 'billed-orders' ? 'Shipped'
                                        : activeTab === 'active-orders' && item?.allBilledParts?.length > 0 ? 'Partially Billed'
                                            : item.status}
                                </p>
                            </td>

                            <td className='px-6 py-2 min-w-max whitespace-nowrap text-center'>
                                {item?.totalAmount ? <CurrencyFormat amount={parseFloat(item?.totalAmount).toFixed(2)} /> : 'NA'}
                            </td>

                            <td className='px-6 py-2 text-center'>
                                {item?.purchaseOrderNumber ? item?.purchaseOrderNumber : 'NA'}
                            </td>

                            <td className='px-6 py-1 text-center'>
                                <button className='bg-primaryColor rounded inline-flex items-center justify-center' onClick={() => showDrawer(item.pORefId)}>
                                    <ChatButton RefId={item.pORefId} color='white' showDrawer={() => showDrawer(item.pORefId)} additionalClasses='text-white text-sm h-8' />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {orderData.length == 0 ? (
                <div style={{ textAlign: 'center', fontSize: '14px', width: '100%', marginTop: '5px' }}>
                    No Data Found
                </div>
            ) : null}
        </div>

    );
}

export default OrderTable;
